import React, { createContext, useContext, useState } from 'react';
import { styled, Box } from '@mui/system';
import ModalUnstyled from '@mui/core/ModalUnstyled';
import PropTypes from 'prop-types';

const StyledModal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Backdrop = styled('div')`
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
  z-index: -1;
`;

const ModalContext = createContext();

const ModalProvider = ({ children }) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [openedModal, setOpenedModal] = useState('');

  const openModal = (modalName) => {
    setOpenedModal(modalName);
    setIsOpen(true);
  };

  const closeModal = () => {
    setOpenedModal('');
    setIsOpen(false);
  };

  const Modal = ({
    width,
    danger,
    transparent = false,
    preventClose = false,
    closeFunction,
    // eslint-disable-next-line no-shadow
    children
  }) => {
    const style = {
      width,
      maxWidth: '1140px',
      maxHeight: '100%',
      position: 'relative',
      color: danger && '#FFF',
      bgcolor: danger ? '#cc0000' : transparent ? '#00000000' : '#FFF',
      border: !transparent && `1px solid ${danger ? '#e70000' : '#E7E7E7'}`,
      borderRadius: '7px',
      py: 3,
      px: 6
    };

    return (
      <StyledModal
        open={modalIsOpen}
        // eslint-disable-next-line prettier/prettier
        onClose={closeFunction || (preventClose ? () => { } : closeModal)}
        BackdropComponent={Backdrop}
      >
        <Box sx={style}>{children}</Box>
      </StyledModal>
    );
  };

  return (
    <ModalContext.Provider
      value={{
        openModal,
        closeModal,
        Modal,
        openedModal
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

function useModal() {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useModal must be used within an ModalProvider');
  }

  return context;
}

ModalProvider.propTypes = {
  children: PropTypes.node
};

export { ModalProvider, useModal };
